import React from 'react';

const Loading = () => {
  return (
    <a className='loadingContainer'>
        <svg viewBox='0 0 32 32'
            xmlns='http://www.w3.org/2000/svg'>
            <g>
                <circle cx='16' cy='16' fill='none' r='14' strokeWidth='4' style={{stroke: 'black', opacity: '0.2'}}></circle>
            </g>
            <g className='circle__svg-circle'>
                <circle cx='16' cy='16' fill='none' r='14' strokeWidth='4' style={{stroke: 'black', strokeDasharray: '80px', strokeDashoffset: '60px'}}></circle>
            </g>
        </svg>
    </a>
  )
}

export default Loading;